import { Component, input, output } from '@angular/core';

import { WidgetRepresentation } from './dashboard-widget.model';

@Component({
  selector: 'app-rep-switcher',
  standalone: true,
  template: `
    @if (reps().length > 1) {
    <div class="flex items-center rounded-lg border border-surface-200/70 p-0.5 dark:border-surface-700/50">
      @for (r of reps(); track r) {
      <button
        type="button"
        (click)="repChange.emit(r)"
        [title]="r"
        [attr.aria-label]="'Show as ' + r"
        [attr.aria-pressed]="r === active()"
        class="flex h-6 w-6 items-center justify-center rounded-md text-xs transition-colors"
        [class]="
          r === active()
            ? 'bg-primary-500 text-white dark:bg-primary-400'
            : 'text-text-muted hover:bg-surface-100 dark:hover:bg-surface-800'
        "
      >
        <i [class]="icon(r)"></i>
      </button>
      }
    </div>
    }
  `,
})
export class RepSwitcherComponent {
  reps = input<WidgetRepresentation[]>([]);
  active = input.required<WidgetRepresentation>();
  repChange = output<WidgetRepresentation>();

  private static readonly ICONS: Record<WidgetRepresentation, string> = {
    number: 'pi pi-hashtag',
    meter: 'pi pi-gauge',
    bar: 'pi pi-chart-bar',
    line: 'pi pi-chart-line',
    donut: 'pi pi-circle',
    pie: 'pi pi-chart-pie',
    radar: 'pi pi-compass',
    list: 'pi pi-list',
    org: 'pi pi-sitemap',
    'stat-chart': 'pi pi-chart-bar',
    'leave-summary': 'pi pi-circle',
    'multi-stat': 'pi pi-th-large',
    clock: 'pi pi-clock',
  };

  icon(r: WidgetRepresentation): string {
    return RepSwitcherComponent.ICONS[r] ?? 'pi pi-chart-bar';
  }
}
